import { useEffect, useState, useRef, useMemo } from "react";
import type { Socket } from "socket.io-client";
import api from "../../../../services/api";
import {
  Stack,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useParams } from "react-router-dom";
import "../../../../componentes/leaflet-migrations";
import "../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import { getLocalMapConfig } from "../../../../utils/easyMapsLocalConfig";
import SliderBarMapsRaw from "../../../../componentes/easyMaps/sideBarEasyMaps";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { ReactComponent as BarIcon } from "../../../../assets/easyMaps/titlebar.svg";
import LoadingUpdateRaw from "../../../../componentes/easyMaps/loadingUpdate";
import { MapaContext, SnackbarState } from "../../../../contexts/mapaContext";
import { ToastContainer } from "react-toastify";
import ToastAlert from "../../../../componentes/easyMaps/toastAlert";
import { network } from "../../../../schemas/elements";
import AlertModal from "../../../../componentes/alertModal";
import PingMapaRaw from "./pingMapa";

const PingMapa = PingMapaRaw as any;
const SliderBarMaps = SliderBarMapsRaw as any;
const LoadingUpdate = LoadingUpdateRaw as any;

interface MapaPingProps {
  socketCliente: Socket;
}

interface MapListItem {
  nome: string;
  id: string;
  tipo: number;
}

interface LatLngZoom {
  lat: number;
  lng: number;
  zoom: number;
}

export default function MapaPing({ socketCliente }: MapaPingProps) {
  const tipo = "easymon";
  const mapRef = useRef<any>(null);
  const theme = useTheme();
  const [snackbar, setSnackbar] = useState<SnackbarState | null>(null);
  const [openAccessDenied, setOpenAccessDenied] = useState(false);
  const [produtos, setProdutos] = useState<any>(false);
  const [map, setMap] = useState<MapDetail | null>(null);
  const [configurationMap, setConfigurationMap] = useState<any>(null);
  const [elements, setElements] = useState<Map<string, any>>(new Map());
  const [elementSelected, setElementSelected] = useState<any | null>(null);
  const [connectionSelected, setConnectionSelected] = useState<any | null>(
    null,
  );
  const [connections, setConnections] = useState<Map<string, any>>(new Map());
  const [fullScreem, setFullScreem] = useState<boolean>(false);
  const [mapas, setMapas] = useState<MapListItem[]>([]);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [iconsElements, setIconsElements] = useState<any[]>([]);
  const [loadingMap, setLoadingMap] = useState<boolean>(true);
  const [sinc, setSinc] = useState<boolean>(false);
  const [checkChanges, setCheckChanges] = useState<boolean>(false);
  const [collapse, setCollapse] = useState<boolean>(false);
  const [lastCollectData, setLastCollectData] = useState<Date | null>(null);
  const [rulerMode, setRulerMode] = useState<boolean>(false);
  const [soundState, setSoundState] = useState<boolean>(false);
  const [hostGroups, setHostGroups] = useState<string[]>([]);

  // atualização otimização
  const [hostsDataMap, setHostsDataMap] = useState<
    Map<string, network.monitor.IHost[]>
  >(new Map());
  const [alertsDataMap, setAlertsDataMap] = useState<
    Map<string, network.monitor.IAlert[]>
  >(new Map());
  const [newAlerts, setNewAlerts] = useState<network.monitor.IAlert[]>([]);
  const [connectionsDataMap, setConnectionsDataMap] = useState<
    Map<string, network.monitor.IConnection>
  >(new Map());
  const [configElementDataMap, setConfigElementDataMap] = useState<
    Map<string, network.monitor.IConfig>
  >(new Map());
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const editmodeRef = useRef<boolean | undefined>(undefined);
  const sincRef = useRef<boolean>(false);
  const { config, configLayer, setConfigLayer } =
    useOutletContext<EasyMapsLayoutContext>();
  const startMapRef = useRef<boolean>(false);

  const latLngZoomFromUrl: LatLngZoom = useMemo(() => {
    const url = new URL(window.location.href);
    const latURL = url.searchParams.get("lat");
    const lngURL = url.searchParams.get("lng");
    const zoomURL = url.searchParams.get("zoom");

    const lat = latURL ? Number(latURL) : NaN;
    const lng = lngURL ? Number(lngURL) : NaN;
    const zoom = zoomURL ? Number(zoomURL) : NaN;

    return { lat, lng, zoom };
  }, []);

  const isMobile: boolean =
    (navigator as any).userAgentData?.mobile === true ||
    window.matchMedia("(pointer: coarse)").matches;

  const styles: Record<string, any> = {
    fullScreem: {
      position: "fixed",
      zIndex: 1300,
      width: "100dvw",
      height: "100dvh",
      left: 0,
      top: 0,
      backgroundColor: theme.palette.background.default,
    },
    noFullScreem: {
      position: "relative",
      ml: { xs: "0px", md: collapse ? "0px" : "340px" },
      width: {
        xs: "100dvw",
        md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
      },
      height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
    },
    loadingMap: {
      position: "absolute",
      zIndex: 1000,
      width: "100%",
      height: "100%",
      backgroundColor:
        theme.palette.mode !== "dark" ? "#e0e0e093" : "#00000093",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 4,
    },
    editMode: {
      position: "absolute",
      zIndex: 1203,
      fontSize: "13px",
      border:
        (fullScreem ? "4px" : "2px") + " solid " + theme.palette.secondary.main,
      display: "flex",
      alignItems: "stop",
      justifyContent: "center",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
    },
    dotEditMode: {
      mt: "-2px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "fit-content",
    },
    textEditMode: {
      mt: "-27px",
      color: "white",
      fontSize: "15px",
      width: "fit-content",
    },
    toastContainer: {
      zIndex: fullScreem ? 1301 : 1200,
      marginTop: (sinc || loadingMap ? 55 : 0) + (fullScreem ? 0 : 60) + "px",
      marginRight: elementSelected ? "355px" : "0",
      visibility: editMode ? "hidden" : "visible",
    },
  };

  useEffect(() => {
    if (newAlerts.length === 0) return;

    newAlerts.forEach((alert, index) => {
      const element = elements.get(alert.elementId);

      ToastAlert({
        alert,
        focus: (id: string) => {
          mapRef?.current?.focusZoomExt(id);
        },
        element,
        theme,
        sound: index === 0 && soundState,
      });
    });

    setNewAlerts([]);
  }, [newAlerts]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    if (config) {
      updateDataElementSocket();
    }
  }, [config]);

  useEffect(() => {
    editmodeRef.current = editMode;
    if (!editMode) {
      updateDataElementSocket();
    }
  }, [editMode]);

  useEffect(() => {
    if (elementSelected == null || editMode == true) return;
    setElementSelected({
      ...elements?.get(elementSelected.id),
    });
  }, [elements]);

  useEffect(() => {
    if (connectionSelected == null || checkChanges) return;
    setConnectionSelected({
      ...connections?.get(connectionSelected.id),
    });
  }, [connections]);

  useEffect(() => {
    if (!id || !config) return;
    // atualiza as confi de layer do mapa para o default
    if (!configLayer?.[id]) {
      setConfigLayer((prev) => ({
        ...(prev || {}),
        [id]: "trafego",
      }));
    }
    const timeInterval = config?.configuracoes?.geo?.atualizacao || 60000;
    const interval = window.setInterval(() => {
      updateDataElementSocket();
    }, timeInterval);

    return () => window.clearInterval(interval);
  }, [id, config]);

  useEffect(() => {
    if (!id || !config) return;
    setLoadingMap(true);
    inicializeMap();
    getIconDB();
    handleApiGetProdutos(tipo);
    handleApiGetMaps();
  }, [id, config]);

  async function inicializeMap(): Promise<void> {
    try {
      await handleApiGetMap(id);
    } catch (e: any) {
      if (e?.response?.status === 403) return;
      throw e;
    }
    await handleApiGetElements(id);
    setLoadingMap(false);
    startMapRef.current = true;
  }

  async function handleApiGetMap(mapId: string | undefined): Promise<void> {
    try {
      const response = await api.post("/easyMaps/map/findMapById", {
        mapId,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: " Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        if (response.data.tipo !== 4) navigate("/easyMaps");
        else {
          const { ConfigMapEasyMaps, ...mapData } = response.data;
          setMap(mapData as MapDetail);
          const base = ConfigMapEasyMaps
            ? ConfigMapEasyMaps
            : { configuracoes: config?.configuracoes?.geo || null };
          const local = getLocalMapConfig(mapId);
          setConfigurationMap(
            local
              ? { ...base, configuracoes: { ...base.configuracoes, ...local } }
              : base,
          );
        }
      }
    } catch (error: any) {
      console.error(error);
      if (error?.response?.status == 403) {
        setOpenAccessDenied(true);
        throw error;
      }
      if (error?.response?.status == 404) navigate("/easyMaps/pages/notFound");
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function handleApiGetElements(
    mapId: string | undefined,
    force = false,
  ): Promise<void> {
    try {
      const response = await api.post("/easyMaps/element/findMany", {
        mapId,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: " Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const data = response.data;
        // transforma os elements em MAP
        const elementsMap = new Map<string, any>(
          data.responseAlerts.map((el: any) => [el.id, el]),
        );
        const connectionsMap = new Map<string, any>(
          data.connections.map((el: any) => [el.id, el]),
        );

        setElements(elementsMap);
        setConnections(connectionsMap);
        updateDataElementSocket(force);
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function updateDataElementSocket(force = false): Promise<void> {
    if ((!force && editmodeRef.current) || sincRef.current) return;

    try {
      sincRef.current = true;
      setSinc(true);
      const responseBuffer = await api.get("/easyMaps/map/lastData", {
        params: { mapId: id },
        responseType: "arraybuffer",
      });
      sincRef.current = false;
      setSinc(false);
      setNewAlerts([]);
      if ((responseBuffer as any).status === "Error") {
        console.error("Error na resposta da última coleta:", responseBuffer);
        setSnackbar({
          children: "Error: Não foi possível sincronizar os elementos",
          severity: "error",
        });
      } else {
        // transforma os elements proto em data
        const message = network.monitor.ElementResponseRoot.decode(
          new Uint8Array(responseBuffer.data),
        );
        const response = network.monitor.ElementResponseRoot.toObject(message, {
          defaults: true,
          longs: Number,
        });

        // trnsforma os elements em MAP
        const updatedData = response;
        const newHostsMap = new Map<string, network.monitor.IHost[]>();
        const newAlertsMap = new Map<string, network.monitor.IAlert[]>();
        const newConnectionsMap = new Map<
          string,
          network.monitor.IConnection
        >();
        const configElementMap = new Map<string, network.monitor.IConfig>();
        const tagsElementMap = new Map<string, string[]>();
        const hostGroupsSet = new Set<string>();
        for (const el of updatedData.elementosResponse) {
          tagsElementMap.set(el.id, Array.isArray(el.tags) ? el.tags : []);
          // hosts por elemento
          if (el.hosts?.length) {
            newHostsMap.set(el.id, el.hosts);
          }
          for (const host of el.hosts || []) {
            if (host.groups) {
              host.groups.forEach((group) => hostGroupsSet.add(group));
            }
          }

          for (const conn of el.connections) {
            newConnectionsMap.set(conn.id, conn);
          }

          // alerts por elemento (ou por host, se preferir)
          if (el.alerts?.length) {
            newAlertsMap.set(el.id, el.alerts);

            // somente os novos
            const freshAlerts = el.alerts.filter(
              (alert: network.monitor.IAlert) => alert.isNew,
            );

            if (freshAlerts.length > 0) {
              setNewAlerts((prev) => {
                const existingKeys = new Set(
                  prev.map((a) => `${a.triggerid}-${a.eventid}`),
                );

                const filtered = freshAlerts.filter(
                  (a) => !existingKeys.has(`${a.triggerid}-${a.eventid}`),
                );

                return [...prev, ...filtered];
              });
            }
          }
          if (el.config) {
            configElementMap.set(el.id, el.config);
          }
        }
        setHostGroups(Array.from(hostGroupsSet));
        setHostsDataMap(newHostsMap);
        setConfigElementDataMap(configElementMap);
        setAlertsDataMap(newAlertsMap);
        setConnectionsDataMap(newConnectionsMap);
        setLastCollectData(new Date(updatedData?.dataColeta) || null);
        setElements((prev) => {
          const next = new Map(prev);
          tagsElementMap.forEach((tags, id) => {
            const elem = next.get(id);
            if (elem) next.set(id, { ...elem, tags });
          });
          return next;
        });
      }
    } catch (error: any) {
      sincRef.current = false;
      setSinc(false);
      console.error("Error ao atualizar os dados dos elementos:", error);
      setSnackbar({
        children: "Error: Não foi possível atualizar",
        severity: "error",
      });
    }
  }

  async function handleApiGetMaps(): Promise<void> {
    try {
      const response = await api.get("/easyMaps/map/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMapas(
            response.data.map((map: any) => ({
              nome: map.titulo,
              id: map.id,
              tipo: map.tipo,
            })),
          );
        }
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function handleApiGetProdutos(tipoParam: string): Promise<void> {
    try {
      const response = await api.post("/cliente/produto/findMany", {
        tipo: tipoParam,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar Clientes",
          severity: "error",
        });
      } else {
        setProdutos(response.data);
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function getIconDB(): Promise<void> {
    try {
      const response = await api.get("/easyMaps/img/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  const handleCollapse = (): void => {
    setCollapse(!collapse);
  };

  const handleFullscreen = (value: boolean): void => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };

  const coordinates = useMemo(() => {
    return Array.from(elements.values())?.map(
      (el) => el?.elementConfig?.config?.coordenadas,
    );
  }, [elements]);

  const onImportComplete = async (): Promise<void> => {
    setLoadingMap(true);
    // force=true: a sincronização (que traz as tags) normalmente é pulada em
    // modo de edição. Após um save em massa, precisamos aplicá-la mesmo assim,
    // senão as tags somem da tela até um F5.
    await handleApiGetElements(id, true);
    setLoadingMap(false);
  };

  const boundsCoordinates = useMemo<number[][]>(() => {
    if (coordinates.length > 0) {
      return coordinates.map((c: any) => [Number(c.lat), Number(c.long)]);
    }
    return [[-6.716659784392299, -47.988281250000014]];
  }, [coordinates]);

  const centerCoordinates = useMemo<number[]>(() => {
    if (
      latLngZoomFromUrl.lat &&
      latLngZoomFromUrl.lng &&
      isNaN(latLngZoomFromUrl.lat) === false &&
      isNaN(latLngZoomFromUrl.lng) === false
    )
      return [Number(latLngZoomFromUrl.lat), Number(latLngZoomFromUrl.lng)];
    return [-10, -48];
  }, [latLngZoomFromUrl]);

  return (
    <MapaContext.Provider
      value={{
        mapId: id,
        tipo: "geo",
        elements,
        setElements,
        elementSelected,
        setElementSelected,
        connections,
        setConnections,
        connectionSelected,
        setConnectionSelected,
        hostGroups,
        editMode,
        setEditMode,
        checkChanges,
        setCheckChanges,
        snackbar,
        setSnackbar,
        updateDataElementSocket,
        configurationMap,
        setConfigurationMap,
        mapRef,
        hostsDataMap,
        alertsDataMap,
        configElementDataMap,
        connectionsDataMap,
        lastCollectData,
        connectionsDataMapPercentTraffic: new Map(),
        connectionsDataMapPercentPower: new Map(),
        rulerMode,
        setRulerMode,
        startMapRef,
        soundState,
        setSoundState,
      }}
    >
      <ToastContainer
        style={styles.toastContainer}
        newestOnTop
        limit={isMobile ? 4 : 5}
      />
      <Stack direction="row">
        {!fullScreem && (
          <SliderBarMaps
            iconsElements={iconsElements}
            collapse={collapse}
            handleCollapse={handleCollapse}
            fullScreem={fullScreem}
          />
        )}

        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {editMode && (
            <Box sx={styles.editMode}>
              <Box sx={styles.dotEditMode}>
                <BarIcon width={"250px"} fill={theme.palette.secondary.main} />
                <Typography sx={styles.textEditMode}>Modo de Edição</Typography>
              </Box>
            </Box>
          )}

          {loadingMap && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" disableShrink />
              <Typography
                fontSize="14px"
                color={(theme.palette.color as any).textEasyMaps}
              >
                Carregando dados do mapa...
              </Typography>
            </Box>
          )}
          <LoadingUpdate
            visible={sinc && !loadingMap}
            elementSelected={!!elementSelected}
            rulerMode={rulerMode}
          />

          <PingMapa
            setFullScreem={handleFullscreen}
            fullScreem={fullScreem}
            socketCliente={socketCliente}
            ref={mapRef}
            iconsElements={iconsElements}
            setIconsElement={setIconsElements}
            title={map?.titulo}
            element={editMode ? elementSelected : null}
            produtos={produtos}
            api={api}
            setSnackbar={setSnackbar}
            mapas={mapas}
            setMapas={setMapas}
            centerCoordinates={centerCoordinates}
            boundsCoordinates={boundsCoordinates}
            onImportComplete={onImportComplete}
            collapse={collapse}
            latLngZoomFromUrl={latLngZoomFromUrl}
          />
        </Stack>
      </Stack>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transitionDuration={1}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
      <AlertModal
        openModal={openAccessDenied}
        setOpenModal={setOpenAccessDenied}
        handleButton={() => navigate("/easyMaps/inicio")}
        severity="error"
        singleButton
        buttonText="Voltar"
        textContent="Você não tem permissão para acessar este mapa, solicite permissão ao administrador."
      />
    </MapaContext.Provider>
  );
}
